module.exports = __webpack_public_path__ + "assets/bunny.9fff907d.svg";